<template>
    <generic-dropdown :wide="true">
        <template slot="title">
            <slot />
        </template>

        <label
            v-if="financial"
            :for="id"
            class="cms-content-our-range-filter__input-label cms-content-our-range-filter__input-label--range"
        >
            <span>{{ minFormatted }}</span>
            <span>{{ maxFormatted }}</span>
        </label>
        <label
            v-else
            :for="id"
            class="cms-content-our-range-filter__input-label cms-content-our-range-filter__input-label--range"
        >
            <span>{{ min }}</span>
            <span>{{ max }}</span>
        </label>
        <div
            class="cms-content-our-range-filter__input-min-max-range"
            :id="id"
            ref="input"
        ></div>
        <span class="cms-content-our-range-filter__current" v-if="financial"
            >{{ minSelectedFormatted }} - {{ maxSelectedFormatted }}</span
        >
        <span class="cms-content-our-range-filter__current" v-else
            >{{ minSelectedFormatted }} - {{ maxSelectedFormatted }} miles</span
        >
    </generic-dropdown>
</template>

<script>
import GenericDropdown from "./GenericDropdown.vue";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";
import NumberFormat from "../../../used-vue/api/NumberFormat";
import noUiSlider from "nouislider";
import "nouislider/distribute/nouislider.css";

export default {
    props: {
        minKey: String,
        maxKey: String,
        step: Number,
        financial: Boolean,
        id: String,
        event: {
            type: Object,
            default: null,
        }
    },
    components: {
        GenericDropdown,
    },
    data() {
        return {
            firstLoad: true,
            firstInteraction: false,
            slider: null,
        };
    },
    methods: {
        priceFormat(value) {
            return `£${NumberFormat(value)}`;
        },
    },
    computed: {
        min() {
            return this.$store.state.availableOptions[this.minKey] ?? null;
        },
        minSelected() {
            return this.$store.state.selectedOptions[this.minKey] ?? null;
        },
        minFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.min)}`;
            }
            return NumberFormat(this.min);
        },
        minSelectedFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.minSelected)}`;
            }
            return NumberFormat(this.minSelected);
        },
        max() {
            return this.$store.state.availableOptions[this.maxKey] ?? null;
        },
        maxSelected() {
            return this.$store.state.selectedOptions[this.maxKey] ?? null;
        },
        maxFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.max)}`;
            }
            return NumberFormat(this.max);
        },
        maxSelectedFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.maxSelected)}`;
            }
            return NumberFormat(this.maxSelected);
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.slider = noUiSlider.create(this.$refs.input, {
                start: [
                    this.minSelected ?? this.min,
                    this.maxSelected ?? this.max
                ],
                connect: true,
                range: {
                    min: this.min,
                    max: this.max,
                },
                step: this.step,
            });

            this.slider.on("update", (values, handle) => {
                // Prevent triggering another API call when slider first initializes
                if (this.firstLoad || (values[0] == this.minSelected && values[1] == this.maxSelected)) {
                    this.firstLoad = false;
                    this.$store.commit("updateOptions", {
                        [this.minKey]: values[0],
                        [this.maxKey]: values[1],
                    });
                    return;
                }
                if (!this.firstInteraction) {
                    this.firstInteraction = true;
                    const { category, label } = this.event;
                    customEvent(category, label, "Interacted");
                }
                this.$store.dispatch("updateOptions", {
                    [this.minKey]: values[0],
                    [this.maxKey]: values[1],
                });
            });
        });
    },
};
</script>
